import React from "react";
import "./muiDatePicker.css";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import * as locales from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { InputAdornment } from "@mui/material";

const MuiDatePicker = ({ value, handleChange, defaultDate, showToolbar = true }) => {
  const { i18n } = useTranslation();
  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={locales[i18n.language]}
      >
        <MobileDatePicker
          className="date-picker"
          minDate={defaultDate}
          slots={{
            openPickerIcon: KeyboardArrowDownIcon
          }}
          format="MMMM - yyyy"
          value={new Date(value)}
          slotProps={{
            textField: { 
              readOnly: true,
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <KeyboardArrowDownIcon />
                  </InputAdornment>
                )
              }
            },
            dialog: {
              className: "custom-dialog-date-picker",
            },
            toolbar: { hidden: !showToolbar } 
          }}
          onChange={(newDate) => handleChange(newDate, "calendar")}
        />
      </LocalizationProvider>
    </>
  );
};

export default MuiDatePicker;
